<template>
  <div>
    <h3>创建图书</h3>
    <el-form @submit.native.prevent="saveBooks" :inline="true">
      <el-form-item label="选择网校">
        <el-select
          v-model="model.maID"
          multiple
          @change="getMajor"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          v-model="model.clID"
          @change="changeClass"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-card>
        <el-form-item label="添加大纲">
          <el-select v-model="model.lineID" multiple placeholder="添加考试大纲">
            <el-option
              v-for="item in outline"
              :key="item.index"
              :label="item.lineName"
              :value="item.lineID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加备考指导">
          <el-select v-model="model.advID" multiple placeholder="添加备考指导">
            <el-option
              v-for="item in advice"
              :key="item.index"
              :label="item.advName"
              :value="item.advID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图书标题">
          <el-input style="width: 550px" v-model="model.booksTitle"></el-input>
        </el-form-item>

        <el-form-item label="出版日期">
          <el-input style="width: 550px" v-model="model.pressDate"></el-input>
        </el-form-item>
        <el-form-item label="出版书号">
          <el-input style="width: 550px" v-model="model.pressISBN"></el-input>
        </el-form-item>

        <el-form-item label="出版社">
          <el-input style="width: 550px" v-model="model.press"></el-input>
        </el-form-item>
        <el-form-item label="图书作者">
          <el-input style="width: 550px" v-model="model.booksAuthor"></el-input>
        </el-form-item>
        <el-form-item label="图书价格">
          <el-input style="width: 550px" v-model="model.booksPrice"></el-input>
        </el-form-item>
        <el-form-item label="销售价格">
          <el-input style="width: 550px" v-model="model.salePrice"></el-input>
        </el-form-item>
      </el-card>
      <el-card style="margin-top: 15px">
        <h5>请上传图书主图(最多五张)</h5>
        <el-upload
          class="upload-demo"
          drag
          :action="$http.defaults.baseURL + '/books/mainimg'"
          multiple
          :on-preview="handlePreview"
          :on-success="mainImgUpload"
          :file-list="mainImgs"
          list-type="picture"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">上传主图(5张)<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">接收：【jpg,png】</div>
        </el-upload>
      </el-card>

      <el-card style="margin-top: 15px">
        <h5>请上传图书详情图(一张)</h5>
        <el-upload
          class="upload-demo"
          drag
          :action="$http.defaults.baseURL + '/books/descimg'"
          :on-preview="handlePreview"
          :on-success="descImgUpload"
          :file-list="descImgs"
          list-type="picture"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">上传详情图(1张)<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">接收：【jpg,png】</div>
        </el-upload>
      </el-card>

      <el-form-item style="margin-top: 25px; float: right">
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      mainImgs: [],
      descImgs: [],
      mainImg: {},
      major: [],
      channel: [],
      course: [],
      shclass: [],
      advice: [],
      outline: [],
      model: {
        fileList: "",
      },
    };
  },

  methods: {
    async saveBooks() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
          mainImgs: this.mainImgs,
          descImgs: this.descImgs,
          press: this.model.press,
          pressDate: this.model.pressDate,
          pressISBN: this.model.pressISBN,
          booksTitle: this.model.booksTitle,
          booksAuthor: this.model.booksAuthor,
          booksPrice: parseInt(this.model.booksPrice),
          salePrice: parseInt(this.model.salePrice),
        };
        const res = await this.$http.post("/books/create", params);
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$router.push("/books/list");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      //console.log(item);
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
        this.getAdvice(coID);
        this.getOutline(coID);
      } catch (error) {
        console.log(error);
      }
    },
    async changeClass(clID) {
      this.getAdvice(clID), this.getOutline(clID);
    },
    async getOutline() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/outline/getline", {
          params,
        });

        this.outline = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
    },
    async getAdvice() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/advice/getadvice", {
          params,
        });

        this.advice = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
      //console.log(this.getgrade);
    },
    mainImgUpload(res, file, fileList) {
      try {
        //console.log(fileList, "mainImgs");
        this.mainImgs = fileList.map((item) => {
          return {
            url: item.response.url,
            name: item.response.name,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    descImgUpload(res, file, fileList) {
      try {
        this.descImgs = fileList.map((item) => {
          return {
            url: item.response.url,
            name: item.response.name,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      console.log(file);
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
  },
};
</script>

<style></style>
